import React from "react";
import { leaf, mainLeaf } from "../../assets";

import { BsFillCaretRightFill } from "react-icons/bs";
import { Link as ScrollLink } from "react-scroll";

import { motion } from "framer-motion";

const Services = () => {
  return (
    <div id="services">
      <img src={mainLeaf} alt="" className="mainLeaf" />

      
      <div className="grad gradient3"></div>

      <div className="mainContent">
        <div className="leftCont">
          <motion.div
            className="treatment"
            whileInView={{ x: [-30, 0] }}
            transition={{ duration: 0.5 }}
          >
            <img src={leaf} alt="" />
            <h1>Asthetic</h1>
            <p>Enhancing your natural beauty.</p>
            <ScrollLink
              className="readBtn"
              to="asthetic"
              smooth={true}
              duration={500}
              offset={-320}
              spy={true}
            >
              Read More <BsFillCaretRightFill className="rightArrow" />
            </ScrollLink>
          </motion.div>
          <motion.div
            className="treatment"
            whileInView={{ x: [-30, 0] }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <img src={leaf} alt="" />
            <h1>Anti-Aging</h1>
            <p>You can get the smooth, line-free skin.</p>
            <ScrollLink
              className="readBtn"
              to="antiAging"
              smooth={true}
              duration={500}
              offset={-320}
              spy={true}
            >
              Read More <BsFillCaretRightFill className="rightArrow" />
            </ScrollLink>
          </motion.div>

          <motion.div
            whileInView={{ x: [-30, 0] }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="treatment"
          >
            <img src={leaf} alt="" />
            <h1>Body Shaping</h1>
            <p>
              A non-invasive treatment that reduces packets of fatty tissues.
            </p>
            <ScrollLink
              className="readBtn"
              to="bodyShaping"
              smooth={true}
              duration={500}
              offset={-320}
              spy={true}
            >
              Read More <BsFillCaretRightFill className="rightArrow" />
            </ScrollLink>
          </motion.div>

          <motion.div
            whileInView={{ x: [-30, 0] }}
            transition={{ duration: 0.5, delay: 0.6 }}
            className="treatment"
          >
            <img src={leaf} alt="" />
            <h1>Dermatology</h1>
            <p>Dermatologists diagnose and treat skin conditions.</p>
            <ScrollLink
              className="readBtn"
              to="dermatology"
              smooth={true}
              duration={500}
              offset={-320}
              spy={true}
            >
              Read More <BsFillCaretRightFill className="rightArrow" />
            </ScrollLink>
          </motion.div>

          <motion.div
            whileInView={{ x: [-30, 0] }}
            transition={{ duration: 0.5, delay: 0.8 }}
            className="treatment"
          >
            <img src={leaf} alt="" />
            <h1>Sexology</h1>
            <p>Resolve any conflicts may have with sexual histories.</p>
            <ScrollLink
              className="readBtn"
              to="sexology"
              smooth={true}
              duration={500}
              offset={-320}
              spy={true}
            >
              Read More <BsFillCaretRightFill className="rightArrow" />
            </ScrollLink>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Services;
